import React, { useEffect, useState } from "react";
import liveLogo from "../../Assets/Images/liveLogo.png";
import {
  Avatar,
  Box,
  FormControl,
  IconButton,
  InputLabel,
  Menu,
  MenuItem,
  Select,
  Tooltip,
  Typography,
} from "@mui/material";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import logo from "../../Assets/Images/logo-faqeer.png";
import { useNavigate } from "react-router-dom";
import { LogoutApi } from "../../DAL/Auth/Auth";
import { enqueueSnackbar } from "notistack";

export default function NavbarSection() {
  const navigate = useNavigate();
  const [language, setLanguage] = useState("en");
  const [open, setOpen] = useState(false);
  const [openProfile, setOpenProfile] = useState(false);
  const [role, setRole] = useState([]);
  const [token, setToken] = useState(localStorage.getItem("admin_token"));
  const [adminData, setAdminData] = useState(null);
  const [anchorEl, setAnchorEl] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleChange = (event) => {
    setLanguage(event.target.value);
  };

  const handleOpen = () => {
    setOpen(true);
  };
  const handleOpen1 = () => {
    setOpenProfile(true);
  };

  const handleLogout = async () => {
    // const resp = await LogoutApi();
    // if (resp.status == true) {
      localStorage.clear();
      navigate("/");
    // } else {
    //   enqueueSnackbar(resp?.message, { variant: "error" });
    // }
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };
  // useEffect(() => {
  //   const data = localStorage.getItem("admin_data");
  //   setAdminData(JSON.parse(data));
  //   setRole(JSON.parse(data)?.roles);
  // }, []);
  return (
    <>
      <Box
        sx={{
          padding: "15px 10px ",
          display: "flex",
          boxShadow: 2,
          alignItems: "center",
          justifyContent: "space-between",
          backgroundColor: "#000",
          position: "fixed",
          height: "6vh",
          width: "100%",
          zIndex: "10",
        }}
      >
        {/* left side */}
        <Box sx={{ display: "flex", alignItems: "center", gap: "20px" }}>
          <img src={logo} alt="" style={{ height: "55px", width: "55px" }} />
          
        </Box>
        {/* right side */}
        <Box sx={{ display: "flex", gap: "10px", alignItems: "center" }}>
          
          {token && (
            <div style={{ display: "flex", alignItems: "center" }}>
              <Avatar
                src={adminData?.profile_pic}
                sx={{ width: 30, height: 30 }}
              />

              <div>
                <IconButton
                  onClick={handleClick}
                  style={{ display: "flex", alignItems: "center" }}
                >
                  <Typography sx={{ color: "white" }}>
                    {adminData?.email}
                  </Typography>
                  {anchorEl ? (
                    <KeyboardArrowUpIcon sx={{ color: "white" }} />
                  ) : (
                    <KeyboardArrowDownIcon sx={{ color: "white" }} />
                  )}
                </IconButton>

                <Menu
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "right",
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                  }}
                >
                  {role[0]?.role == 1 ? (
                    ""
                  ) : (
                    <MenuItem onClick={()=>navigate("/change-password")}>Change Password</MenuItem>
                  )}
                  <MenuItem onClick={handleLogout}>Logout</MenuItem>
                </Menu>
              </div>
            </div>
          )}
        </Box>
      </Box>
    </>
  );
}
